import PageWrapper from "../../shared/wizard/PageWrapper";
import ToggleDiv from "../components/ToggleDiv";
import { states } from "../../../constants/data";
import Styles from "../AnonForms.module.css";
import { yesNo, yesNoUnsure } from "../../../constants/options";
import { textToBoolean } from "../../../utilities/dataUtilities";

function Injury({ fields, utilities }) {
  const {
    createToggleInput,
    createNoLabelInput,
    createNoLabelSelect,
    createTextArea
  } = utilities;

  return (
    <PageWrapper legendInfo="Injury Information:">
      <div className={Styles.labelInputContainer}>
        <div className={Styles.inputContainer}>
          <ToggleDiv width="100%" flexDir="row">
            {createToggleInput(fields.wasAnyoneInjured, "100%", yesNoUnsure, true)}
          </ToggleDiv>
        </div>
      </div>
      {textToBoolean(fields.wasAnyoneInjured.value) && (
        <div className={`${Styles.labelInputContainer} ${Styles.fadeIn}`}>
          <p className={Styles.sectionLabel}>Injured Party Information:</p>
          <div className={Styles.inputContainer}>
            {createNoLabelInput(fields.injuredFirstName, "50%", Styles.anonInput)}
            {createNoLabelInput(fields.injuredLastName, "50%", Styles.anonInput)}
          </div>
          <div className={Styles.inputContainer}>
            {createNoLabelInput(fields.injuredAddress, "50%", Styles.anonInput)}
            {createNoLabelInput(fields.injuredCity, "50%", Styles.anonInput)}
          </div>
          <div className={Styles.inputContainer}>
            {createNoLabelSelect(fields.injuredState, "33%", states, Styles.anonSelect, "Select a State")}
            {createNoLabelInput(fields.injuredZipcode, "33%", Styles.anonInput)}
            {createNoLabelInput(fields.injuredCounty, "34%", Styles.anonInput)}
          </div>
          <div className={Styles.inputContainer}>
            {createTextArea(fields.injuryDescription, "100%", true, Styles.damageText)}
          </div>
          <div className={Styles.inputContainer}>
            <ToggleDiv>
              {createToggleInput(fields.wasTreatmentProvided, "100%", yesNo, true)}
            </ToggleDiv>
          </div>
          {fields.wasTreatmentProvided.value && (
            <div className={`${Styles.fadeIn} ${Styles.treatment}`}>
              <p className={Styles.sectionLabel}> Provider Information: </p>
              <div className={Styles.inputContainer}>
                {createNoLabelInput(fields.medicalProviderFirstName, "33%", Styles.anonInput)}
                {createNoLabelInput(fields.medicalProviderLastName, "33%", Styles.anonInput)}
                {createNoLabelInput(fields.medicalProviderAddress, "33%", Styles.anonInput)}
              </div>
              <div className={Styles.inputContainer}>
                {createNoLabelInput(fields.medicalProviderCity, "34%", Styles.anonInput)}
                {createNoLabelSelect(fields.medicalProviderState, "33%", states, Styles.anonSelect, "Select a State")}
                {createNoLabelInput(fields.medicalProviderZipcode, "33%", Styles.anonInput)}
              </div>
            </div>
          )}
        </div>
      )}
    </PageWrapper>
  );
}

export default Injury;
